import React, { useState } from 'react';

import { Col, Empty, Row, Space } from 'antd';

import {
  FormAddButton,
  FormCancelButton,
  FormSaveButton,
} from 'common/components';

import { IXOneHierarchyTree } from 'pages/product-full-view/components/product-hierarchy/IXOneHierarchyTree';
import { IXOneHierarchyAddModal } from '../ixone-credit-card/IXOneHierarchy';

import { useGetProductFullView } from 'hooks';
import { useIXOneCapture } from '../ixone-credit-card/IXOneContext';

import {
  getAllIXOneRows,
  getNewRowData,
  mappingHierarchies,
  recalculateFee,
} from './utils';
import { toArray } from 'utils/array';

import * as creditCardServices from 'services/creditCardEula';

export const IXOneHierarchyModal = (props) => {
  const { productId, hierarchies, offModalListHierarchy } = props;
  const [visibleAddHierarchy, setVisibleAddHierarchy] = useState(false);

  const { selectedHierarchies, onSelectHierarchy, ixoneGridApi } =
    useIXOneCapture();

  const [tempSelectedHierarchy, setTempSelectedHierarchy] = useState(
    selectedHierarchies?.[productId]?.selectedHierarchy
  );

  const { productFull } = useGetProductFullView({ productId });

  const isEmptyHierarchy = hierarchies?.length === 0;

  const handleSelectHierarchy = () => {
    onSelectHierarchy({
      hierarchyValue: tempSelectedHierarchy,
      productId,
    });

    const allRowData = getAllIXOneRows(ixoneGridApi);

    const isSelectHierarchy = Object.keys(tempSelectedHierarchy).length > 0;

    const newRowData = recalculateFee({
      productId,
      hierarchyValue: tempSelectedHierarchy,
      allRowData,
      isSelectHierarchy,
    });

    ixoneGridApi.api.applyTransaction({
      update: newRowData,
    });
    offModalListHierarchy();
  };

  const handleAddNewHierarchySuccess = async () => {
    const allRowData = getAllIXOneRows(ixoneGridApi);

    const response = await creditCardServices.getProductsForCapture({
      productIds: toArray(productId),
    });

    if (response?.isSuccess) {
      const { products } = response?.data;
      const hierarchies = products?.[0]?.hierarchies;

      const newRowData = getNewRowData({
        allRowData,
        productId,
        newHierarchies: hierarchies,
      });

      ixoneGridApi.api.applyTransaction({
        update: newRowData,
      });
    }
  };

  return (
    <div>
      <div
        style={{ minHeight: 440 }}
        className='ixone-section--hierarchy-tree scroller'
      >
        {isEmptyHierarchy ? (
          <Empty />
        ) : (
          <IXOneHierarchyTree /* I'll refactor this component later */
            hierarchyData={mappingHierarchies(hierarchies)}
            publishPackageList={[]}
            isLoading={false}
            isInCheckPublishErrorMode={false}
            selectedHierarchy={tempSelectedHierarchy}
            onSelectHierarchy={(hierarchyValue) =>
              setTempSelectedHierarchy(hierarchyValue)
            }
          />
        )}
      </div>
      <IXOneHierarchyModalFooter
        onAddNewHierarchy={() => setVisibleAddHierarchy(true)}
        onCancel={offModalListHierarchy}
        onSubmit={handleSelectHierarchy}
      />
      {visibleAddHierarchy && (
        <IXOneHierarchyAddModal
          productId={productId}
          currentProduct={productFull}
          visible={visibleAddHierarchy}
          setVisible={setVisibleAddHierarchy}
          onCallApiSuccess={handleAddNewHierarchySuccess}
        />
      )}
    </div>
  );
};

const IXOneHierarchyModalFooter = ({
  onAddNewHierarchy,
  onCancel,
  onSubmit,
}) => {
  return (
    <Row align='middle' justify='space-between' style={{ paddingTop: 12 }}>
      <Col>
        <FormAddButton text='Add Hierarchy' onClick={onAddNewHierarchy} />
      </Col>
      <Col>
        <Space>
          <FormCancelButton onClick={onCancel} />
          <FormSaveButton text='Submit' onClick={onSubmit} />
        </Space>
      </Col>
    </Row>
  );
};
